var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass:
        "order-return-review-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    One-off has been created.\n  "),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _vm._m(0),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "return-customer-details" },
        [
          _c(
            "el-card",
            { attrs: { shadow: "never" } },
            [
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          One-off summary\n        "),
                ]),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v(
                    "\n          Created On: " +
                      _vm._s(_vm.createdOn) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Item\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "8px" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.device.product.description)
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#6E6E6E", margin: "0 !important" },
                    },
                    [
                      _vm._v(
                        "\n            ASIN: " +
                          _vm._s(_vm.device.sku) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.device.estimated_delivery
                    ? _c(
                        "p",
                        {
                          staticClass: "estimated-delivery",
                          staticStyle: { margin: "0 !important" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.device.estimated_delivery) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col" }, [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Customer info\n        "),
                ]),
                _c("br"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col" },
                [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Name\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.customer.first_name) +
                          " " +
                          _vm._s(_vm.customer.last_name)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Phone Number\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.phone_number))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Email\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.email))]),
                  ]),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-row",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c("div", { staticClass: "flex-1" }, [
                        _vm._v("\n            Street\n          "),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.address.address1) +
                            " " +
                            _vm._s(_vm.address.address2)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            City\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.city))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            State/province/area\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.state))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Zip code\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.zip_code))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n            Country\n          "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.country))]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n    one-off has been generated and sent to the customer. Once the "
      ),
      _c("br"),
      _vm._v(
        "device(s) are dispatched by Ring, the customer will be notified of the"
      ),
      _c("br"),
      _vm._v(" tracking information via email.\n  "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }